import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {CartItem, MenuItem} from '../../../core/models/cart-item.model';
import {FormatDataService} from '../../../core/services/format-data.service';
import { CartStore } from '../../../core/stores/cart.store';
import {SharedOrderService} from '../../../core/services/shared-order.service';

@Component({
  selector: 'app-cart-item',
  templateUrl: './cart-item.component.html',
  styleUrls: ['./cart-item.component.scss']
})
export class CartItemComponent implements OnInit{
  @Input()
  public item: CartItem;
  @Input()
  public hasEdit = false;
  @Input()
  public hasDelete = true;
  @Input()
  public hasPrice = true;
  @Input()
  public transparent = false;
  @Input()
  public brandColor = false;
  @Input()
  public border: ('bottom' | 'top' | 'none') = 'bottom';
  @Input()
  isValidLeadTime = true;
  @Input()
  isValidDay = true;
  @Input()
  isValidFulfillment = true;
  @Input()
  isValidDatetimeRange = true;
  @Input()
  isValidRestaurantFulfillment = true;
  @Input()
  isValidRestaurantTime = true;
  @Input()
  public buttonsDisabled = false;
  @Input()
  public showModifierPrice = false;
  @Input()
  public currencySign = '$';
  @Input()
  public showTimeBasedErrorMessage = false;
  @Input()
  public serviceChargeName = null;
  @Input()
  public displayKyooFee = false;
  @Output()
  public edit = new EventEmitter();
  @Output()
  public delete = new EventEmitter();

  public get isBorderTop() {
    return this.border === 'top';
  }

  public get isNoBorder() {
    return this.border === 'none';
  }

  public get lines(): string {
    return this.isNoBorder ? 'none' : null;
  }

  public get availableDays(): string {
    return this.formatDataService.getFormattedDailyAvailabilityText(this.item.variation.dailyAvailability);
  }

  public get availableFulfillments(): string {
    return this.formatDataService.getFormattedAvailableFulfillments(this.item.variation.availableInFulfillments);
  }

  public get availableText(): string {
    if (this.showTimeBasedErrorMessage && !this.isValidDay && !this.isValidFulfillment) {
      return `Available for ${this.availableFulfillments.toLowerCase()} on ${this.availableDays}.`;
    } else if (this.showTimeBasedErrorMessage && !this.isValidDay) {
      return `This item is only available on ${this.availableDays}.`;
    } else if (!this.isValidFulfillment) {
      return `This item is only available for ${this.availableFulfillments}.`;
    } else {
      return '';
    }
  }

  public isAllModifiersHidden(modifiers: MenuItem[]): boolean {
    return modifiers.every(modifier => modifier.hiddenFromCustomer);
  }

  public get datetimeRangeText(): string {
    if (!this.isValidDatetimeRange) {
      return this.formatDataService.availableFromUntilText(this.item.variation.availableFrom, this.item.variation.availableUntil, true);
    } else {
      return '';
    }
  }

  public get isShowFutureOrderError(): boolean {
    const date = new Date(this.cartStore.pickupAt);
    const currentDate = new Date();
    const isShow = this.showTimeBasedErrorMessage && this.item.isFutureOrder && date.getDate() === currentDate.getDate();
    this.cartStore.isFutureOrderError = isShow;
    return isShow;
  }

  constructor(
    public formatDataService: FormatDataService,
    private cartStore: CartStore,
    public sharedOrderService: SharedOrderService
  ) {
  }

  ngOnInit() {
  }

  public getFormattedPrice(price: string | number, quantity = 1): string {
      return (+price * quantity).toFixed(2);
  }

  public cleanedName(name: string): string {
    return name.replace('(*)', '').replace('(#)', '').replace('(^)', '').trim();
  }

  public modifierPrice(modifier: MenuItem): string {
    if (modifier.price.amount > 0 && this.showModifierPrice) {
      return ` (+ ${this.currencySign}${this.getFormattedPrice(modifier.price.amount / 100)})`;
    } else {
      return '';
    }
  }

  public editItemFromCart() {
    this.edit.emit();
  }

  public deleteItemFromCart() {
    this.delete.emit();
  }
}
